export default __webpack_public_path__ + "static/media/wK.871fa0e3.svg";